import Vue from 'vue'
import Router from 'vue-router'
import Header from '../pages/header.vue'
import Index from '../pages/index/index.vue'
import Bottoms from '../pages/index/bottoms.vue'
import headerSwiper from "../pages/indexComponents/headerSwiper.vue"
import recommend from "../pages/indexComponents/recommend.vue"
import content2 from "../pages/index/content2.vue"
import childcompany from "../pages/indexComponents/childcompany.vue"
//最新动态
import Dyindex from '../pages/dynamic/dyindex.vue'
Vue.use( Router )
//商品详情
import Details from '../pages/details/details.vue'
//例表详细
import Listdeta from '../pages/listindetail/listdeta.vue'
//登录与注册
import Login from '../pages/user/login.vue'
import Regist from '../pages/user/registered.vue'
//我的订单
import Order from '../pages/theorder/order.vue'
//在线加盟
import Join from '../pages/join/join.vue'
//购物车
import shopCart from '../pages/shoppin/shoppin.vue'
//商品列表页
import productlist from "../pages/details/productlist.vue"
// 关于我们
import aboutour from "../pages/details/aboutour.vue"
// 忘记密码
import forgetPassword from "../pages/user/forgetPassword.vue"
// 选择城市
import choosecity from "../pages/index/choosecity.vue"
// 选择菜场
import marketlist from "../pages/index/marketlist.vue"
//订单信息
import orderinfo from "../pages/shoppin/orderinfo.vue"
//支付成功
import paysuccess from "../pages/shoppin/buysuccess.vue"
export default new Router(
{
    linkActiveClass: "my-active",
    // mode: 'history',
    // 路由跳转到顶部
    // scrollBehavior()
    // {
    //     const routerPush = Rouwter.prototype.push
    //     Router.prototype.push = function push( location )
    //     {
    //         return routerPush.call( this, location ).catch( error => error )
    //     }
    //     return { x: 0, y: 0 };
    // },
    routes: [
    {
        path: '/',
        name: 'Index',
        component: Index
    },
    {
        path: '/header',
        name: 'Header',
        component: Header
    },
    {
        path: '/bottoms',
        name: 'Bottoms',
        component: Bottoms
    },
    {
        path: '/dyindex',
        name: 'Dyindex',
        component: Dyindex
    },
    {
        path: '/details',
        name: 'Details',
        component: Details
    },
    {
        path: '/listdeta',
        name: 'Listdeta',
        component: Listdeta
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/regist',
        name: 'Regist',
        component: Regist
    },
    {
        path: '/order',
        name: 'Order',
        component: Order
    },
    {
        path: '/join',
        name: 'Join',
        component: Join
    },
    {
        path: '/shopCart',
        name: '/shopCart',
        component: shopCart
    },
    {
        path: '/headerSwiper',
        name: '/headerSwiper',
        component: headerSwiper
    },
    {
        path: '/recommend',
        name: '/recommend',
        component: recommend
    },
    {
        path: '/content2',
        name: 'content2',
        component: content2,
    },
    {
        path: '/childcompany',
        name: '/childcompany',
        component: childcompany
    },
    {
        path: '/productlist',
        name: '/productlist',
        component: productlist
    },
    {
        path: '/aboutour',
        name: '/aboutour',
        component: aboutour
    },
    {
        path: '/forgetPassword',
        name: '/forgetPassword',
        component: forgetPassword
    },
    {
        path: '/choosecity',
        name: '/choosecity',
        component: choosecity
    },
    {
        path: '/marketlist',
        name: '/marketlist',
        component: marketlist
    },
    {
        path: '/orderinfo',
        name: '/orderinfo',
        component: orderinfo
    },
    {
        path: '/paysuccess',
        name: '/paysuccess',
        component: paysuccess
    },
    {
        path: "/famoussnacks",
        name: "famoussnacks",
        component: () => import( "../pages/famoussnacks/index.vue" )
    },
    {
        path: "/famoussnacks_list",
        name: "famoussnacks_list",
        component: () => import( "../pages/famoussnacks/list.vue" )
    },
    {
        path: "/famoussnacks_locality",
        name: "famoussnacks_locality",
        component: () => import( "../pages/famoussnacks_locality/index.vue" )
    },
    {
        path: "/famoussnacks_locality_list",
        name: "famoussnacks_locality_list",
        component: () => import( "../pages/famoussnacks_locality/list.vue" )
    },
    {
        path: "/discount",
        name: "discount",
        component: () => import( "../pages/discount" )
    },
    {
        path: "/indextwo",
        name: "indextwo",
        component: () => import( "../pages/discount/indextwo" )
    },
    {
        path: "/discount_list",
        name: "discount_list",
        component: () => import( "../pages/discount/list.vue" )
    },
    {
        path: "/discount_list_two",
        name: "discount_list_two",
        component: () => import( "../pages/discount/listTwo.vue" )
    } ]
} )